import Viewfinder from './Viewfinder';

export default Viewfinder;
